import { render, staticRenderFns } from "./About.vue?vue&type=template&id=1fa33478&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBanner,QIcon} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QBanner,QIcon}, component.options.components || {})
